// Always keep the BuyoutRights entry sorted manually

import { CustomClients } from '@thehubz/shared/branding';

// because sortDataSource is set to false in the BuyoutRights FormControlModel
export const BuyoutRights = [
  { _id: 'compositionmusic', name: 'Composition music' },
  { _id: 'image', name: 'Image' },
  { _id: 'stockmaterial', name: 'Stock material' },
  { _id: 'video', name: 'Video' },
  { _id: 'voiceover', name: 'Voice-over' },
];

export const BuyoutRightsMakeOS = [
  { _id: 'creators', name: 'Creators', secondLvl: true },
  { _id: 'cast', name: 'Cast' },
  { _id: 'voiceover', name: 'Voice-over' },
  { _id: 'music', name: 'Music', secondLvl: true },
  { _id: 'stock', name: 'Stock', secondLvl: true },
  { _id: 'others', name: 'Others' },
];

export const BuyoutRightsMakeOSSecondLevel = [
  //creators
  { _id: 'director', name: 'Director', firstLvl: 'creators' },
  { _id: 'dop', name: 'DoP', firstLvl: 'creators' },
  { _id: 'photographer', name: 'Photographer', firstLvl: 'creators' },
  { _id: 'contentcreator', name: 'Content creator', firstLvl: 'creators' },
  { _id: 'illustrator', name: 'Illustrator', firstLvl: 'creators' },
  { _id: 'other', name: 'Other', firstLvl: 'creators' },
  //music
  { _id: 'archive', name: 'Archive', firstLvl: 'music' },
  { _id: 'composed', name: 'Composed', firstLvl: 'music' },
  { _id: 'licensed', name: 'Licensed', firstLvl: 'music' },
  //stock
  { _id: 'movingimage', name: 'Moving image', firstLvl: 'stock' },
  { _id: 'stillimage', name: 'Still image', firstLvl: 'stock' },
  { _id: 'stockmusic', name: 'Music', firstLvl: 'stock' },
  { _id: 'sound', name: 'Sound', firstLvl: 'stock' },
  { _id: 'graphic', name: 'Graphic', firstLvl: 'stock' },
];

export const BuyoutRightsSeat = [
  { _id: 'image', name: 'Buyout-Informationen (Image)' },
  { _id: 'music', name: 'Musik/Sound' },
  { _id: 'talents', name: 'Talents' },
  { _id: 'voiceover', name: 'Voice-over' },
  { _id: 'Zusatzinformationen', name: 'Zusatzinformationen (Notes)' },
];

export const LicenseRegion = [
  { _id: 'asia', name: 'Asia' },
  { _id: 'austria', name: 'Austria' },
  { _id: 'china', name: 'China' },
  { _id: 'czechrepublic', name: 'Czech Republic' },
  { _id: 'europe', name: 'Europe' },
  { _id: 'france', name: 'France' },
  { _id: 'germany', name: 'Germany' },
  { _id: 'italy', name: 'Italy' },
  { _id: 'mexico', name: 'Mexico' },
  { _id: 'northamerica', name: 'North America' },
  { _id: 'other', name: 'Other' },
  { _id: 'poland', name: 'Poland' },
  { _id: 'portugal', name: 'Portugal' },
  { _id: 'southamerica', name: 'South America' },
  { _id: 'spain', name: 'Spain' },
  { _id: 'switzerland', name: 'Switzerland' },
  { _id: 'taiwan', name: 'Taiwan' },
  { _id: 'turkey', name: 'Turkey' },
  { _id: 'unitedkingdom', name: 'United Kingdom' },
  { _id: 'usa', name: 'USA' },
  { _id: 'worldwide', name: 'Worldwide' },
];

export const BuyoutType = [
  { _id: 'active', name: 'Active' },
  { _id: 'passive', name: 'Passive' },
];

export const TerritoryList = [
  { _id: 'afghanistan', name: 'Afghanistan', categories: ['global'] },
  { _id: 'albania', name: 'Albania', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'algeria', name: 'Algeria', categories: ['global', 'emea'] },
  { _id: 'andorra', name: 'Andorra', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'angola', name: 'Angola', categories: ['global', 'emea'] },
  { _id: 'antiguaandbarbuda', name: 'Antigua and Barbuda', categories: ['global'] },
  { _id: 'argentina', name: 'Argentina', categories: ['global', 'americas'] },
  { _id: 'armenia', name: 'Armenia', categories: ['global', 'eugeografisch'] },
  { _id: 'australia', name: 'Australia', categories: ['global', 'apac'] },
  { _id: 'austria', name: 'Austria', categories: ['global', 'eugeografisch', 'emea', 'dach'] },
  { _id: 'azerbaijan', name: 'Azerbaijan', categories: ['global', 'eugeografisch'] },
  { _id: 'bahamas', name: 'Bahamas', categories: ['global'] },
  { _id: 'bahrain', name: 'Bahrain', categories: ['global', 'emea'] },
  { _id: 'bangladesh', name: 'Bangladesh', categories: ['global'] },
  { _id: 'barbados', name: 'Barbados', categories: ['global'] },
  { _id: 'belarus', name: 'Belarus', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'belgium', name: 'Belgium', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'belize', name: 'Belize', categories: ['global', 'americas'] },
  { _id: 'benin', name: 'Benin', categories: ['global', 'emea'] },
  { _id: 'bhutan', name: 'Bhutan', categories: ['global'] },
  { _id: 'bolivia', name: 'Bolivia', categories: ['global', 'americas'] },
  { _id: 'bosniaandherzegovina', name: 'Bosnia and Herzegovina', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'botswana', name: 'Botswana', categories: ['global', 'emea'] },
  { _id: 'brazil', name: 'Brazil', categories: ['global', 'americas', 'lhamericas'] },
  { _id: 'brunei', name: 'Brunei', categories: ['global', 'apac'] },
  { _id: 'bulgaria', name: 'Bulgaria', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'burkinafaso', name: 'Burkina Faso', categories: ['global', 'emea'] },
  { _id: 'burundi', name: 'Burundi', categories: ['global', 'emea'] },
  { _id: 'cambodia', name: 'Cambodia', categories: ['global', 'apac'] },
  { _id: 'cameroon', name: 'Cameroon', categories: ['global', 'emea'] },
  { _id: 'canada', name: 'Canada', categories: ['global', 'americas', 'lhamericas'] },
  { _id: 'capeverde', name: 'Cape Verde', categories: ['global', 'emea'] },
  { _id: 'centralafricanrepublic', name: 'Central African Republic', categories: ['global', 'emea'] },
  { _id: 'chad', name: 'Chad', categories: ['global', 'emea'] },
  { _id: 'chile', name: 'Chile', categories: ['global', 'americas'] },
  { _id: 'china', name: 'China', categories: ['global', 'apac', 'lhapac'] },
  { _id: 'colombia', name: 'Colombia', categories: ['global', 'americas'] },
  { _id: 'comoros', name: 'Comoros', categories: ['global', 'emea'] },
  { _id: 'congo', name: 'Congo', categories: ['global', 'emea'] },
  { _id: 'cookislands', name: 'Cook Islands', categories: ['global'] },
  { _id: 'costarica', name: 'Costa Rica', categories: ['global', 'americas'] },
  { _id: "côted'ivoire", name: "Côte d'Ivoire ", categories: ['global', 'emea'] },
  { _id: 'croatia', name: 'Croatia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'cuba', name: 'Cuba', categories: ['global', 'americas'] },
  { _id: 'cyprus', name: 'Cyprus', categories: ['global', 'emea'] },
  { _id: 'czechrepublic', name: 'Czech Republic', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'denmark', name: 'Denmark', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'djibouti', name: 'Djibouti', categories: ['global', 'emea'] },
  { _id: 'dominica', name: 'Dominica', categories: ['global'] },
  { _id: 'dominicanrepublic', name: 'Dominican Republic', categories: ['global', 'americas'] },
  { _id: 'ecuador', name: 'Ecuador', categories: ['global', 'americas'] },
  { _id: 'egypt', name: 'Egypt', categories: ['global', 'emea'] },
  { _id: 'elsalvador', name: 'El Salvador', categories: ['global', 'americas'] },
  { _id: 'equatorialguinea', name: 'Equatorial Guinea', categories: ['global', 'emea'] },
  { _id: 'eritrea', name: 'Eritrea', categories: ['global', 'emea'] },
  { _id: 'estonia', name: 'Estonia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'eswatini', name: 'Eswatini', categories: ['global', 'emea'] },
  { _id: 'ethiopia', name: 'Ethiopia', categories: ['global', 'emea'] },
  { _id: 'fiji', name: 'Fiji', categories: ['global', 'apac'] },
  { _id: 'finland', name: 'Finland', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'france', name: 'France', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'gabon', name: 'Gabon', categories: ['global', 'emea'] },
  { _id: 'gambia', name: 'Gambia', categories: ['global', 'emea'] },
  { _id: 'georgia', name: 'Georgia', categories: ['global', 'eugeografisch'] },
  { _id: 'germany', name: 'Germany', categories: ['global', 'eugeografisch', 'emea', 'dach'] },
  { _id: 'ghana', name: 'Ghana', categories: ['global', 'emea'] },
  { _id: 'greece', name: 'Greece', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'grenada', name: 'Grenada', categories: ['global'] },
  { _id: 'guatemala', name: 'Guatemala', categories: ['global', 'americas'] },
  { _id: 'guinea', name: 'Guinea', categories: ['global', 'emea'] },
  { _id: 'guinea-bissau', name: 'Guinea-Bissau', categories: ['global', 'emea'] },
  { _id: 'guyana', name: 'Guyana', categories: ['global'] },
  { _id: 'haiti', name: 'Haiti', categories: ['global', 'americas'] },
  { _id: 'honduras', name: 'Honduras', categories: ['global', 'americas'] },
  { _id: 'hungary', name: 'Hungary', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'iceland', name: 'Iceland', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'india', name: 'India', categories: ['global', 'apac', 'lhapac'] },
  { _id: 'indonesia', name: 'Indonesia', categories: ['global', 'apac'] },
  { _id: 'iran', name: 'Iran', categories: ['global', 'emea'] },
  { _id: 'iraq', name: 'Iraq', categories: ['global', 'emea'] },
  { _id: 'ireland', name: 'Ireland', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'israel', name: 'Israel', categories: ['global', 'emea'] },
  { _id: 'italy', name: 'Italy', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'jamaica', name: 'Jamaica', categories: ['global', 'americas'] },
  { _id: 'japan', name: 'Japan', categories: ['global', 'apac'] },
  { _id: 'jordan', name: 'Jordan', categories: ['global', 'emea'] },
  { _id: 'kazakhstan', name: 'Kazakhstan', categories: ['global', 'eugeografisch'] },
  { _id: 'kenya', name: 'Kenya', categories: ['global', 'emea'] },
  { _id: 'kiribati', name: 'Kiribati', categories: ['global'] },
  { _id: 'northkorea', name: 'North Korea', categories: ['global'] },
  { _id: 'southkorea', name: 'South Korea', categories: ['global', 'apac'] },
  { _id: 'kuwait', name: 'Kuwait', categories: ['global', 'emea'] },
  { _id: 'kyrgyzstan', name: 'Kyrgyzstan', categories: ['global'] },
  { _id: 'laos', name: 'Laos', categories: ['global', 'apac'] },
  { _id: 'kosovo', name: 'Kosovo', categories: ['global', 'eugeografisch'] },
  { _id: 'latvia', name: 'Latvia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'lebanon', name: 'Lebanon', categories: ['global', 'emea'] },
  { _id: 'lesotho', name: 'Lesotho', categories: ['global', 'emea'] },
  { _id: 'liberia', name: 'Liberia', categories: ['global', 'emea'] },
  { _id: 'libya', name: 'Libya', categories: ['global', 'emea'] },
  { _id: 'liechtenstein', name: 'Liechtenstein', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'lithuania', name: 'Lithuania', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'luxembourg', name: 'Luxembourg', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'madagascar', name: 'Madagascar', categories: ['global', 'emea'] },
  { _id: 'malawi', name: 'Malawi', categories: ['global', 'emea'] },
  { _id: 'malaysia', name: 'Malaysia', categories: ['global', 'apac'] },
  { _id: 'maldives', name: 'Maldives', categories: ['global'] },
  { _id: 'mali', name: 'Mali', categories: ['global', 'emea'] },
  { _id: 'malta', name: 'Malta', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'marshallislands', name: 'Marshall Islands', categories: ['global'] },
  { _id: 'mauritania', name: 'Mauritania', categories: ['global', 'emea'] },
  { _id: 'mauritius', name: 'Mauritius', categories: ['global', 'emea'] },
  { _id: 'mexico', name: 'Mexico', categories: ['global', 'americas'] },
  { _id: 'micronesiafederatedstatesof', name: 'Micronesia, Federated States of', categories: ['global'] },
  { _id: 'moldova', name: 'Moldova', categories: ['global', 'eugeografisch'] },
  { _id: 'monaco', name: 'Monaco', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'mongolia', name: 'Mongolia', categories: ['global', 'apac'] },
  { _id: 'montenegro', name: 'Montenegro', categories: ['global', 'eugeografisch'] },
  { _id: 'morocco', name: 'Morocco', categories: ['global', 'emea'] },
  { _id: 'mozambique', name: 'Mozambique', categories: ['global', 'emea'] },
  { _id: 'myanmar', name: 'Myanmar', categories: ['global'] },
  { _id: 'namibia', name: 'Namibia', categories: ['global', 'emea'] },
  { _id: 'nauru', name: 'Nauru', categories: ['global'] },
  { _id: 'nepal', name: 'Nepal', categories: ['global'] },
  { _id: 'netherlands', name: 'Netherlands', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'newzealand', name: 'New Zealand', categories: ['global', 'apac'] },
  { _id: 'nicaragua', name: 'Nicaragua', categories: ['global', 'americas'] },
  { _id: 'niger', name: 'Niger', categories: ['global', 'emea'] },
  { _id: 'nigeria', name: 'Nigeria', categories: ['global', 'emea'] },
  { _id: 'niue', name: 'Niue', categories: ['global'] },
  { _id: 'northmacedonia', name: 'North Macedonia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'norway', name: 'Norway', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'oman', name: 'Oman', categories: ['global', 'emea'] },
  { _id: 'pakistan', name: 'Pakistan', categories: ['global'] },
  { _id: 'palau', name: 'Palau', categories: ['global'] },
  { _id: 'panama', name: 'Panama', categories: ['global', 'americas'] },
  { _id: 'papuanewguinea', name: 'Papua New Guinea', categories: ['global', 'apac'] },
  { _id: 'paraguay', name: 'Paraguay', categories: ['global', 'americas'] },
  { _id: 'peru', name: 'Peru', categories: ['global', 'americas'] },
  { _id: 'philippines', name: 'Philippines', categories: ['global', 'apac'] },
  { _id: 'poland', name: 'Poland', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'portugal', name: 'Portugal', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'qatar', name: 'Qatar', categories: ['global', 'emea'] },
  { _id: 'romania', name: 'Romania', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'russia', name: 'Russia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'rwanda', name: 'Rwanda', categories: ['global', 'emea'] },
  { _id: 'saintkittsandnevis', name: 'Saint Kitts and Nevis', categories: ['global'] },
  { _id: 'saintlucia', name: 'Saint Lucia', categories: ['global'] },
  { _id: 'saintvincentandthegrenadines', name: 'Saint Vincent and the Grenadines', categories: ['global'] },
  { _id: 'samoa', name: 'Samoa', categories: ['global'] },
  { _id: 'sanmarino', name: 'San Marino', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'saotomeandpríncipe', name: 'São Tomé and Príncipe', categories: ['global', 'emea'] },
  { _id: 'saudiarabia', name: 'Saudi Arabia', categories: ['global', 'emea'] },
  { _id: 'senegal', name: 'Senegal', categories: ['global', 'emea'] },
  { _id: 'serbia', name: 'Serbia', categories: ['global', 'eugeografisch'] },
  { _id: 'seychelles', name: 'Seychelles', categories: ['global', 'emea'] },
  { _id: 'sierraleone', name: 'Sierra Leone', categories: ['global', 'emea'] },
  { _id: 'singapore', name: 'Singapore', categories: ['global', 'apac'] },
  { _id: 'slovakia', name: 'Slovakia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'slovenia', name: 'Slovenia', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'solomonislands', name: 'Solomon Islands', categories: ['global'] },
  { _id: 'somalia', name: 'Somalia', categories: ['global', 'emea'] },
  { _id: 'southafrica', name: 'South Africa', categories: ['global', 'emea'] },
  { _id: 'spain', name: 'Spain', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'srilanka', name: 'Sri Lanka', categories: ['global'] },
  { _id: 'sudan', name: 'Sudan', categories: ['global', 'emea'] },
  { _id: 'suriname', name: 'Suriname', categories: ['global'] },
  { _id: 'swaziland', name: 'Swaziland', categories: ['global'] },
  { _id: 'sweden', name: 'Sweden', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'switzerland', name: 'Switzerland', categories: ['global', 'eugeografisch', 'emea', 'dach'] },
  { _id: 'syria', name: 'Syria', categories: ['global', 'emea'] },
  { _id: 'tajikistan', name: 'Tajikistan', categories: ['global'] },
  { _id: 'tanzania', name: 'Tanzania', categories: ['global', 'emea'] },
  { _id: 'thailand', name: 'Thailand', categories: ['global', 'apac'] },
  { _id: 'timorleste', name: 'Timor Leste', categories: ['global'] },
  { _id: 'togo', name: 'Togo', categories: ['global', 'emea'] },
  { _id: 'tonga', name: 'Tonga', categories: ['global'] },
  { _id: 'trinidadandtobago', name: 'Trinidad and Tobago', categories: ['global'] },
  { _id: 'tunisia', name: 'Tunisia', categories: ['global', 'emea'] },
  { _id: 'turkey', name: 'Turkey', categories: ['global', 'eugeografisch'] },
  { _id: 'turkmenistan', name: 'Turkmenistan', categories: ['global'] },
  { _id: 'tuvalu', name: 'Tuvalu', categories: ['global'] },
  { _id: 'uganda', name: 'Uganda', categories: ['global', 'emea'] },
  { _id: 'ukraine', name: 'Ukraine', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'unitedarabemirates', name: 'United Arab Emirates', categories: ['global', 'emea'] },
  { _id: 'unitedkingdom', name: 'United Kingdom', categories: ['global', 'eugeografisch', 'emea', 'lhemea'] },
  { _id: 'unitedstates', name: 'United States', categories: ['global', 'americas', 'lhamericas'] },
  { _id: 'uruguay', name: 'Uruguay', categories: ['global', 'americas'] },
  { _id: 'uzbekistan', name: 'Uzbekistan', categories: ['global'] },
  { _id: 'vanuatu', name: 'Vanuatu', categories: ['global'] },
  { _id: 'vaticancity', name: 'Vatican City', categories: ['global', 'eugeografisch', 'emea'] },
  { _id: 'venezuela', name: 'Venezuela', categories: ['global', 'americas'] },
  { _id: 'vietnam', name: 'Vietnam', categories: ['global', 'apac'] },
  { _id: 'yemen', name: 'Yemen', categories: ['global', 'emea'] },
  { _id: 'zambia', name: 'Zambia', categories: ['global', 'emea'] },
  { _id: 'zimbabwe', name: 'Zimbabwe', categories: ['global', 'emea'] },
];

export const TerritoryCategories = [
  { _id: 'global', name: 'Global' },
  { _id: 'eugeografisch', name: 'Europe geografisch' },
  { _id: 'emea', name: 'EMEA' },
  { _id: 'dach', name: 'DACH' },
  { _id: 'apac', name: 'APAC' },
  { _id: 'americas', name: 'AMERICAS' },
];

export const TerritoryCategoriesLufthansaGroup = [
  { _id: 'lhemea', name: 'LH EMEA' },
  { _id: 'lhamericas', name: 'LH Americas' },
  { _id: 'lhapac', name: 'LH APAC' },
];

export const MediaCategories = [
  { _id: 'allmedia', name: 'All media' },
  { _id: 'socialmedia', name: 'All Social media' },
  { _id: 'onlinemedia', name: 'All Online media' },
  { _id: 'printmedia', name: 'All Print media' },
  { _id: 'internalusemedia', name: 'Internal use/media' },
  { _id: 'directmarketing', name: 'Direct marketing' },
  { _id: 'livecommunicationevents', name: 'Live communication/events' },
  { _id: 'publicrelations', name: 'PR (Public Relations)' },
];

export const MediaLists = [
  { _id: 'affiliatemarketing', name: 'Affiliate Marketing', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'brochures', name: 'Brochures', categories: ['allmedia', 'printmedia'] },
  { _id: 'cinema', name: 'Cinema', categories: ['allmedia'] },
  { _id: 'directmail', name: 'Direct Mail', categories: ['allmedia', 'printmedia', 'directmarketing'] },
  { _id: 'dooh', name: 'DOOH', categories: ['allmedia'] },
  { _id: 'emailmarketing', name: 'Email Marketing', categories: ['allmedia', 'onlinemedia', 'directmarketing'] },
  { _id: 'events', name: 'Events', categories: ['allmedia', 'directmarketing', 'livecommunicationevents'] },
  { _id: 'facebook', name: 'Facebook', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'flyers', name: 'Flyers', categories: ['allmedia', 'printmedia', 'directmarketing'] },
  { _id: 'imagebrochures', name: 'Image Brochures', categories: ['allmedia', 'printmedia', 'publicrelations'] },
  { _id: 'inappadvertising', name: 'In-App Advertising', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'instagram', name: 'Instagram', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'internalmagazines', name: 'Internal Magazines', categories: ['allmedia', 'internalusemedia'] },
  { _id: 'internalnewsletters', name: 'Internal Newsletters', categories: ['allmedia', 'internalusemedia'] },
  { _id: 'linkedin', name: 'LinkedIn', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'livestreaming', name: 'Live Streaming', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'magazines', name: 'Magazines', categories: ['allmedia', 'printmedia'] },
  { _id: 'newsletters', name: 'Newsletters', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'newspapers', name: 'Newspapers', categories: ['allmedia', 'printmedia'] },
  { _id: 'onlineadvertisingdisplay', name: 'Online Advertising/Display', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'ooh', name: 'OOH', categories: ['allmedia'] },
  { _id: 'pinterest', name: 'Pinterest', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'pos', name: 'POS', categories: ['allmedia', 'directmarketing', 'livecommunicationevents'] },
  { _id: 'pressreleases', name: 'Press Releases', categories: ['allmedia', 'publicrelations'] },
  { _id: 'snapchat', name: 'Snapchat', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'streamingplatforms', name: 'Streaming Platforms', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'tiktok', name: 'TikTok', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'tradefairs', name: 'Trade Fairs', categories: ['allmedia', 'directmarketing', 'livecommunicationevents'] },
  { _id: 'tv', name: 'TV', categories: ['allmedia'] },
  { _id: 'video-blogs', name: 'Video-Blogs', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'video-podcasts', name: 'Video-Podcasts', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'vimeo', name: 'Vimeo', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'webvideomarketing', name: 'Web Video Marketing', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'webinars', name: 'Webinars', categories: ['allmedia', 'onlinemedia'] },
  { _id: 'x', name: 'X', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'xing', name: 'Xing', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
  { _id: 'youtube', name: 'YouTube', categories: ['allmedia', 'socialmedia', 'onlinemedia'] },
];

export const buyoutRightsObj = (brandingKey: string) => {
  switch (brandingKey) {
    case CustomClients.SEAT:
      return BuyoutRightsSeat;
    default:
      return BuyoutRights;
  }
};
